import { CarrierType, ScannerType, MaterialType, State } from "../../carrier/carrier-enum";
import { ErrorDetail } from "../../carrier/error-detail";
import { Container } from "./container";

export class Carrier extends Container{
    	/** The carrier type. */
      carrierType:CarrierType;

	 /** The scanner type. */
	  scannerType:ScannerType;

	 /** The state. */
      state:State;

	 /** The product type. */
      productType:string;
	
      materialType:MaterialType;
      
      //From  the UI carrier class
      _id: string;
      errors:Array<ErrorDetail>;
      isOpenForEdit: boolean;
      isDirty: boolean;
      visible: boolean;
      errorCount: number;
}